const getMenus = state => state.menuList.data;

export { getMenus };



// WEBPACK FOOTER //
// ./src/selectors/menus.js